import React, { memo } from 'react';
import { ZapIcon, ShieldIcon, HeartIcon, DropletIcon } from 'lucide-react';
const FunctionalShots = () => {
  return <section className="py-20 bg-gradient-to-br from-blue-50 via-white to-blue-50" data-id="element-281">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282">
        <div className="text-center mb-16" data-id="element-283">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-blue-500 text-white shadow-sm mb-4" data-id="element-284">
            PATENTED TECHNOLOGY
          </span>
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-285">
            Functional Shots On Demand
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-286">
            Our patented solution offers customizable beverage options designed
            with your spa's wellness philosophy in mind
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-287">
          {/* Energy Shot */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-288">
            <div className="bg-yellow-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-289">
              <ZapIcon className="h-8 w-8 text-yellow-500" data-id="element-290" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-291">
              Energy Shot
            </h3>
            <p className="text-gray-600 text-center" data-id="element-292">
              A refreshing combination of ingredients selected to provide a
              pleasant experience during spa treatments and recovery.
            </p>
            <div className="mt-6 text-center" data-id="element-293">
              <span className="inline-block px-3 py-1 bg-yellow-50 text-yellow-700 rounded-full text-sm font-medium" data-id="element-294">
                ⚡ Revitalizing blend
              </span>
            </div>
          </div>
          {/* Immunity Shot */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-295">
            <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-296">
              <ShieldIcon className="h-8 w-8 text-green-500" data-id="element-297" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-298">
              Immunity Shot
            </h3>
            <p className="text-gray-600 text-center" data-id="element-299">
              A carefully selected mix of ingredients that many guests enjoy as
              part of their wellness journey at your spa.
            </p>
            <div className="mt-6 text-center" data-id="element-300">
              <span className="inline-block px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-medium" data-id="element-301">
                🛡️ Wellness ritual
              </span>
            </div>
          </div>
          {/* Relaxation Shot */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-302">
            <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-303">
              <HeartIcon className="h-8 w-8 text-blue-500" data-id="element-304" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-305">
              Relaxation Shot
            </h3>
            <p className="text-gray-600 text-center" data-id="element-306">
              A soothing combination of flavors that may help create moments of
              tranquility and enhance the spa experience.
            </p>
            <div className="mt-6 text-center" data-id="element-307">
              <span className="inline-block px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium" data-id="element-308">
                🧘 Deep relaxation
              </span>
            </div>
          </div>
          {/* Alkaline Water */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-309">
            <div className="bg-cyan-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-310">
              <DropletIcon className="h-8 w-8 text-cyan-500" data-id="element-311" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-312">
              Alkaline Water
            </h3>
            <p className="text-gray-600 text-center" data-id="element-313">
              pH-balanced water that offers a refreshing alternative to regular
              water with a smooth taste experience.
            </p>
            <div className="mt-6 text-center" data-id="element-314">
              <span className="inline-block px-3 py-1 bg-cyan-50 text-cyan-700 rounded-full text-sm font-medium" data-id="element-315">
                💧 Refreshing hydration
              </span>
            </div>
          </div>
        </div>
        <div className="mt-16 bg-white p-8 rounded-xl shadow-md max-w-4xl mx-auto" data-id="element-316">
          <h3 className="text-2xl font-bold text-navy-950 mb-4 text-center" data-id="element-317">
            The Ultimate Spa Enhancement
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-318">
            <div data-id="element-319">
              <ul className="space-y-4" data-id="element-320">
                <li className="flex" data-id="element-321">
                  <div className="flex-shrink-0" data-id="element-322">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-323">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-324">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-325" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-326">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-327">
                      Personalized Experience
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-328">
                      Guests can customize their wellness beverages based on
                      their personal preferences throughout their spa journey.
                    </p>
                  </div>
                </li>
                <li className="flex" data-id="element-329">
                  <div className="flex-shrink-0" data-id="element-330">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-331">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-332">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-333" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-334">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-335">
                      Wellness Options
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-336">
                      Support your guests with a variety of beverage choices
                      that complement treatments and enhance their wellness
                      journey.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div data-id="element-337">
              <ul className="space-y-4" data-id="element-338">
                <li className="flex" data-id="element-339">
                  <div className="flex-shrink-0" data-id="element-340">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-341">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-342">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-343" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-344">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-345">
                      Enhance Guest Satisfaction
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-346">
                      Offer a premium amenity that guests will appreciate and
                      mention in their reviews and recommendations.
                    </p>
                  </div>
                </li>
                <li className="flex" data-id="element-347">
                  <div className="flex-shrink-0" data-id="element-348">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-349">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-350">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-351" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-352">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-353">
                      Elevate Your Brand
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-354">
                      Create memorable impressions with a unique beverage
                      experience that distinguishes your spa from competitors.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-355">
            <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-356">
              Schedule Your Demo Today
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default FunctionalShots;